import { render, staticRenderFns } from "./PreviewEmailModal.vue?vue&type=template&id=4501829a&scoped=true"
import script from "./PreviewEmailModal.vue?vue&type=script&lang=js"
export * from "./PreviewEmailModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewEmailModal.vue?vue&type=style&index=0&id=4501829a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501829a",
  null
  
)

export default component.exports